import { useLayoutEffect, useRef, useState } from "react"
import { validateEmail } from "./validator"

export const useEmailInput = () => {
  const [email, setEmail] = useState("")
  const [isEmailValid, setIsEmailValid] = useState(true)

  const onEmailChange = (email: string) => {
    setIsEmailValid(validateEmail(email))
    setEmail(email)
  }

  return { email, isEmailValid, onEmailChange }
}

export const useFoodBrandMaxWidth = ({
  brand = "",
  marginRight = 0,
}: {
  brand?: string | null
  marginRight?: number
}) => {
  const foodNutritionRef = useRef<HTMLDivElement>(null)
  const [brandMaxWidth, setBrandMaxWidth] = useState("100%")
  const width = foodNutritionRef.current?.clientWidth

  useLayoutEffect(() => {
    setBrandMaxWidth(`calc(100% - ${width}px - ${marginRight}px)`)
  }, [brand, foodNutritionRef.current, width])

  return { brandMaxWidth, foodNutritionRef }
}
